import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, getToken, setToken, clearToken } from "../lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=guest, obj=user
  const [ready, setReady] = useState(false);

  const refresh = useCallback(async () => {
    const token = getToken();
    if (!token) { setUser(false); setReady(true); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      clearToken();
      setUser(false);
    } finally { setReady(true); }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);
  // Capture referral code (?ref=username) so a VirtuStars+ sharer gets rewarded on signup
  useEffect(() => {
    const ref = new URLSearchParams(window.location.search).get("ref");
    if (ref) localStorage.setItem("vs_ref", ref);
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };
  const register = async (payload) => {
    const ref = localStorage.getItem("vs_ref");
    const { data } = await api.post("/auth/register", ref ? { ...payload, ref } : payload);
    localStorage.removeItem("vs_ref");
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };
  const logout = async () => {
    clearToken();
    setUser(false);
  };
  const patchUser = (patch) => setUser((u) => (u ? { ...u, ...patch } : u));

  return (
    <AuthCtx.Provider value={{ user, ready, login, register, logout, refresh, patchUser, setUser }}>
      {children}
    </AuthCtx.Provider>
  );
}
